<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
                [class.text-danger]="controls?.errors != null"> *</span></label>
<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
        [class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">
        <!-- tooltip-message es el icono de error -->
        <tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
                [tooltipMessage]="tooltipMessage" [submitted]="submitted"></tooltip-message>

        <textarea #textArea class="form-control" [class.text-uppercase]="format === 'M'"
                [class.text-lowercase]="format === 'm'" [placeholder]="placeholder"
                [class.is-invalid]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
                [(ngModel)]="value" [readonly]="disabled || readonly" (blur)="onBlur($any($event.target).value)"
                (input)="onInput($any($event.target).value)" (focus)="onFocus($any($event.target).value)"
                (keydown.control.arrowleft)="ArrowLeft($event)" [rows]="rows" [cols]="cols"
                [ngStyle]="{'height': height, 'width': width}"
                (keydown.control.arrowright)="ArrowRight($event)"></textarea>
</div>

<!-- error-message es el mansaje que aparece abajo del componente -->
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
        [tooltipMessage]="tooltipMessage" [submitted]="submitted"></error-message>